import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { isNotBlank } from '@/utils/string-utils';
import React, { FC } from 'react';

interface Props {
  image?: string;
  content?: string;
  fileName?: string;
  /** Names the tile for a screen reader without drawing a caption over the image. */
  altText?: string;
  onClick?: () => void;
}

export const AttachmentImage: FC<Props> = (props: Props) => {
  const { image, content, fileName, altText, onClick } = props;
  return (
    <Box
      position={'relative'}
      // A phone fits three of the design's tiles across its width, a desktop the larger tile the
      // desktop design draws. A fixed 150px left only two per row on a 375px screen.
      width={{ xs: '100px', sm: '150px' }}
      height={{ xs: '100px', sm: '150px' }}
      borderRadius={'12px'}
      border={(theme: Theme) => `1px solid ${theme.colors.borderColor}`}
      overflow={'hidden'}
      sx={{ cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}>
      <img
        src={content ? `data:image/jpeg;base64,${content}` : image ? image : undefined}
        alt={altText ?? ''}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '12px',
        }}
      />
      {isNotBlank(fileName) && (
        <Typography
          sx={(theme: Theme) => ({
            color: 'white',
            position: 'absolute',
            bottom: 0,
            width: '100%',
            fontSize: '12px',
            lineHeight: '16px',
            padding: theme.spacing(1),
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          })}>
          {fileName}
        </Typography>
      )}
    </Box>
  );
};
